import {NavigationState} from '../../../common/navigator';
import {CompleteCategory} from '../../../common/utils';
import * as React from 'react';
// import {Link} from 'react-router';
import { Logger } from '../../../common/logger/logger';
import { EventType } from '../../../common/logger/event-type';
import { Category } from '@wix/answers-api';

export interface CategoryListProps {
	categories: CompleteCategory[];
	goToState: (state: NavigationState, data: any) => void;
	onSelectCallback?: () => void;
	logger?: Logger;
}

export class CategoryList extends React.Component<CategoryListProps, any> {
	categoryClick (category: Category) {
		const props = this.props;
		props.goToState(NavigationState.category, category.id);
		if (props.onSelectCallback) {
			props.onSelectCallback();
		}
		if (props.logger) {
			props.logger.logEvent(EventType.SELECT_CATEGORY, {category});
		}
	}

	render () {
		const item = (category: CompleteCategory) => (
			<li key={category.id} className='title'>
				<a onClick={() => this.categoryClick(category)}>{category.name}</a>
			</li>
		);

		return (
			<ul className='categories'>
					{this.props.categories.map(item)}
			</ul>
		);
	}
}
